export const GAME_TIME_SECS = 120000;

/**
 * Si es true: no hay acceso a escenario 3 en adelante (estratificación, tratamiento, etc.).
 * Redirige al hub con aviso y solo permite ir a resultados. Desactivar cuando el contenido esté listo.
 */
export const GAME_LOCK_SCENARIOS_BEYOND_SCENARIO_2 = true;

export const ROUTES = {
	HOME: "/",
	REGISTER: "/register",
	PRESENTATION: "/presentation",
	START_GAME: "/start-game",
	START_GAME2: "/start-game2",
	START_GAME3: "/start-game3",
	START_GAME4: "/start-game4",
	START_GAME5: "/start-game5",
	TRANSITION_SCENARIOS: "/scenarios",

	SCENARIO1_INTRO: "/scenario1-intro",
	SCENARIO1_INTRO2: "/scenario1-intro2",
	SCENARIO1_INSTRUCTIONS: "/scenario1-instructions",

	SCENARIO2: "/scenario2",
	SCENARIO2_INTRO: "/scenario2-intro",
	SCENARIO2_FIN: "/scenario2-fin",
	SCENARIO2_QUIZ1: "/scenario2-quiz1",
	SCENARIO2_QUIZ2: "/scenario2-quiz2",
	SCENARIO2_QUIZ3: "/scenario2-quiz3",
	SCENARIO2_QUIZ4: "/scenario2-quiz4",
	SCENARIO2_QUIZ5: "/scenario2-quiz5",
	SCENARIO2_QUIZ6: "/scenario2-quiz6",
	SCENARIO2_CONTEXT1: "/scenario2-context1",
	SCENARIO2_CONTEXT2: "/scenario2-context2",
	SCENARIO2_CONTEXT3: "/scenario2-context3",
	SCENARIO2_CONTEXT4: "/scenario2-context4",
	SCENARIO2_CONTEXT5: "/scenario2-context5",
	SCENARIO2_CONTEXT6: "/scenario2-context6",
	

	SCENARIO3: "/scenario3",
	SCENARIO3_INTRO: "/scenario3-intro",
	SCENARIO3_QUIZ1: "/scenario3-quiz1",
	SCENARIO3_QUIZ2: "/scenario3-quiz2",
	SCENARIO3_QUIZ3: "/scenario3-quiz3",
	SCENARIO3_QUIZ4: "/scenario3-quiz4",
	SCENARIO3_QUIZ5: "/scenario3-quiz5",
	SCENARIO3_QUIZ6: "/scenario3-quiz6",
	SCENARIO3_CONTEXT1: "/scenario3-context1",
	SCENARIO3_CONTEXT2: "/scenario3-context2",
	SCENARIO3_CONTEXT3: "/scenario3-context3",
	SCENARIO3_CONTEXT4: "/scenario3-context4",
	SCENARIO3_CONTEXT5: "/scenario3-context5",
	SCENARIO3_CONTEXT6: "/scenario3-context6",
	SCENARIO3_FINALOSRESULTS: "/scenario3-final-os-results",
	SCENARIO3_PEACEI: "/scenario3-peace-i",
	SCENARIO3_EVALUACION: "/scenario3-evaluacion",
	SCENARIO3_DESAFIO: "/scenario3-desafio",
	SCENARIO3_PISTAEVALUACIONGERIATRICOS: "/scenario3-pista-evaluacion-geriatricos",
	SCENARIO3_EVALUACIONGERIATRICOS: "/scenario3-evaluacion-geriatricos",
	SCENARIO3_ESCALAGERIATRICA: "/scenario3-escala-geriatrica",
	SCENARIO3_RETROALIMENTACION: "/scenario3-retroalimentacion",
	SCENARIO3_FIN: "/scenario3-fin",
	SCENARIO3_FIN2: "/scenario3-fin2",

	SCENARIO4: "/scenario4",
	SCENARIO4_INTRO: "/scenario4-intro",
	SCENARIO4_QUIZ1: "/scenario4-quiz1",
	SCENARIO4_QUIZ2: "/scenario4-quiz2",
	SCENARIO4_QUIZ3: "/scenario4-quiz3",
	SCENARIO4_QUIZ4: "/scenario4-quiz4",
	SCENARIO4_QUIZ5: "/scenario4-quiz5",
	SCENARIO4_QUIZ6: "/scenario4-quiz6",
	SCENARIO4_QUIZ7: "/scenario4-quiz7",
	SCENARIO4_CONTEXT1: "/scenario4-context1",
	SCENARIO4_CONTEXT2: "/scenario4-context2",
	SCENARIO4_CONTEXT3: "/scenario4-context3",
	SCENARIO4_CONTEXT4: "/scenario4-context4",
	SCENARIO4_CONTEXT5: "/scenario4-context5",
	SCENARIO4_CONTEXT6: "/scenario4-context6",
	SCENARIO4_SUSPENSIONTRATAMIENTO: "/scenario4-suspension-tratamiento",
	SCENARIO4_RETROALIMENTACION: "/scenario4-retroalimentacion",
	SCENARIO4_RADIOTERAPIA: "/scenario4-radioterapia",
	SCENARIO4_PREGUNTA9: "/scenario4-pregunta9",
	SCENARIO4_FIN: "/scenario4-fin",

	SCENARIO5: "/scenario5",
	SCENARIO5_INTRO: "/scenario5-intro",
	SCENARIO5_QUIZ1: "/scenario5-quiz1",
	SCENARIO5_QUIZ2: "/scenario5-quiz2",
	SCENARIO5_QUIZ3: "/scenario5-quiz3",
	SCENARIO5_QUIZ4: "/scenario5-quiz4",
	SCENARIO5_QUIZ5: "/scenario5-quiz5",
	SCENARIO5_QUIZ6: "/scenario5-quiz6",
	SCENARIO5_CONTEXT1: "/scenario5-context1",
	SCENARIO5_CONTEXT2: "/scenario5-context2",
	SCENARIO5_CONTEXT3: "/scenario5-context3",
	SCENARIO5_CONTEXT4: "/scenario5-context4",
	SCENARIO5_CONTEXT5: "/scenario5-context5",
	SCENARIO5_CONTEXT6: "/scenario5-context6",
	
	SCENARIO5_CONCLUSION: "/scenario5-conclusion",
	SCENARIO5_RESULTADOS: "/scenario5-resultados",
	SCENARIO5_FIN: "/scenario5-fin",

	SUPERTEST_INTRO: "/supertest-intro",
	SUPERTEST_INSTRUCTIONS: "/supertest-instructions",
	SUPERTEST: "/supertest",
	SUPERTEST_2: "/supertest-2",
	SUPERTEST_3: "/supertest-3",

	FINAL_SCENE: "/final-scene",
	CONGRATULATIONS: "/congratulations",
	END: "/end",
	RESULTS: "/results",
	GAMEOVER: "/gameover",

	WARMUP: "/warmup"
};

export const SCENARIOS = {
	SCENARIO_1: "---",
	SCENARIO_2: "65127bfe70cc5310ac640cbd",
	SCENARIO_3: "65127cfd7b2f5959ecc41031",
	SCENARIO_4: "65127d067b2f5959ecc41033",
	SCENARIO_5: "65127d167b2f5959ecc41037",
	SUPERTEST: "---",
};

export const QUIZZES = {
	QUIZ1: "65127e987b2f5959ecc4104c",
	QUIZ2: "65127f5d7b2f5959ecc4105a",
	QUIZ3: "65127fac7b2f5959ecc41061",

	QUIZ4: "651280137b2f5959ecc41063",
	QUIZ5: "6513e9b7eb4ed56660961616",
	QUIZ6: "69dca2af4dd7abbb22532c2f",

	QUIZ7: "69dca2d94dd7abbb22532c30",
	QUIZ8: "6512801d7b2f5959ecc41065",
	QUIZ9: "6512802c7b2f5959ecc41067",
	QUIZ10: "651280ca7b2f5959ecc4106f",
	QUIZ11: "651280f07b2f5959ecc41076",
	QUIZ12: "69dca3224dd7abbb22532c31",
	QUIZ13: "651280f37b2f5959ecc41078",
	
	QUIZ14: "651280f67b2f5959ecc4107a",	
	QUIZ15: "69dcab364dd7abbb22532c3d",	

	SUPERTEST_1: "6513e9b7eb4ed56660961616",
	SUPERTEST_2: "6513e9bbeb4ed56660961618",
	SUPERTEST_3: "6513e9beeb4ed5666096161a",
};

/* Sellos: IDs del juego de nutrición (no forman parte del mapa QUIZ1–QUIZ14 del escape room). */
const FIRST_STAMP_QUIZ_ID = "65127e987b2f5959ecc4104c";
const SECOND_STAMP_QUIZ_ID = "65127fac7b2f5959ecc41061";
const THIRD_STAMP_QUIZ_ID = "651280f97b2f5959ecc4107c";
const FOURTH_STAMP_QUIZ_ID = "6512814f7b2f5959ecc41083";
const FIFTH_STAMP_QUIZ_ID = "651282327b2f5959ecc4108c";

export const STAMPS_QUIZZES = [
	FIRST_STAMP_QUIZ_ID,
	SECOND_STAMP_QUIZ_ID,
	THIRD_STAMP_QUIZ_ID,
	FOURTH_STAMP_QUIZ_ID,
	FIFTH_STAMP_QUIZ_ID,
];

export const QUESTION_ALREADY_ANSWERED_BUTTON = `<div class="d-flex align-items-center justify-content-center px-3">
		AVANZAR
	</div>`;

export const QUESTION_ALREADY_ANSWERED_TEXT = `<div>
		<div class="txt22">Ya has resuelto esta prueba anteriormente.</div>
		<div class="txt22 mt-2">¡Sigue adelante!</div>
	</div>`;
